export const OPT_OUT_CACHE = "OptOutCache";
const TWENTY_FOUR_HOUR_INTERVAL_CHECK_MS = 24 * 60 * 60 * 1000;
const HUNDRED_YEARS_IN_MS = 100 * 365 * 24 * 60 * 60 * 1000;

export function getOptOutCache() {
    try {
        return JSON.parse(window.localStorage.getItem(OPT_OUT_CACHE)) || {};
    } catch {
        return {};
    }
}

export function setOptOutCache(obj) {
    window.localStorage.setItem(OPT_OUT_CACHE, JSON.stringify(obj));
}

export function hasCheckedOptOutRecently(userId) {
    const cache = getOptOutCache();
    const expiry = cache[userId];
    return expiry && Date.now() < expiry;
}

export function updateOptOutCache(userId, isOptedOut) {
    const cache = getOptOutCache();
    cache[userId] = isOptedOut
        ? Date.now() + HUNDRED_YEARS_IN_MS
        : Date.now() + TWENTY_FOUR_HOUR_INTERVAL_CHECK_MS;
    setOptOutCache(cache);
}